import * as React from 'react';

interface IconProps {
	isHovered: boolean;
}

export function LayersIcon({ isHovered }: IconProps) {
	return (
		<div className='select-none p-2 flex items-center justify-center'>
			<svg
				xmlns='http://www.w3.org/2000/svg'
				width='24'
				height='24'
				viewBox='0 0 24 24'
				fill='none'
				stroke={isHovered ? '#FF69B4' : 'currentColor'}
				strokeWidth='2'
				strokeLinecap='round'
				strokeLinejoin='round'
			>
				<path
					d='m12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83Z'
					style={{
						transform: isHovered ? 'scale(1.1)' : 'scale(1)',
						transition: 'transform 0.3s ease-in-out',
						transformOrigin: 'center'
					}}
				/>
				<path
					d='m22 17.65-9.17 4.16a2 2 0 0 1-1.66 0L2 17.65'
					style={{
						transform: isHovered ? 'translateY(-2px)' : 'translateY(0)',
						transition: 'transform 0.3s ease-in-out'
					}}
				/>
				<path
					d='m22 12.65-9.17 4.16a2 2 0 0 1-1.66 0L2 12.65'
					style={{
						transform: isHovered ? 'translateY(-1px)' : 'translateY(0)',
						transition: 'transform 0.3s ease-in-out'
					}}
				/>
			</svg>
		</div>
	);
}
